/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { ContentZoneContext } from "cms/components/context";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";

const YoutubeComponentDisplay = () => {
    
    const ctx = useContext(ContentZoneContext);
    const component = ctx.component;

    const { useEmbed, embed, title, width, height, src, srcid } = component;
    const hasContent = embed || src || srcid;

    let video_url;
    if (srcid) {
        video_url = `https://www.youtube.com/embed/${srcid}`;
    } else {
        video_url = src;
    }

    return (
        <>
            {!useEmbed && hasContent && (
                <div className='fluid-width-video-wrapper'>
                    <iframe
                        style={{ border: 0 }}
                        width={width}
                        height={height}
                        src={video_url}
                        title={title}
                        frameBorder='0'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                        allowFullScreen
                    ></iframe>
                </div>
            )}
            {useEmbed && hasContent && (
                <div
                    style={{ width: "100%", display: "flex", justifyContent: "center" }}
                    dangerouslySetInnerHTML={{ __html: embed }}
                />
            )}

            {!embed && !video_url &&
                <EmptyContentMessage hasContent={hasContent} component={component} />
            }
        </>
    );
};

YoutubeComponentDisplay.displayName = "YoutubeComponentDisplay";
export { YoutubeComponentDisplay };


/*
< iframe
width = "1056"
height = "587"
src = "https://www.youtube.com/embed/yL4ntNPwfwA"
title = "My Tourism has ASCENDED"
frameBorder = "0"
allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
allowFullScreen > < /iframe>

< iframe
width = "1831"
height = "855"
src = "https://www.youtube.com/embed/yL4ntNPwfwA"
title = "My Tourism has ASCENDED"
frameBorder = "0"
allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
allowFullScreen > < /iframe>
*/
